import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatNavList, MatListItem } from '@angular/material/list';
import { TranslatePipe } from '@ngx-translate/core';
import { PermissionIfDirective } from '@pecan/entities/permissions';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatNavList, PermissionIfDirective, MatListItem, TranslatePipe],
    selector: 'app-main-menu',
    styleUrls: ['./main-menu.component.scss'],
    templateUrl: './main-menu.component.html',
})
export class MainMenuComponent {
    private _router: Router = inject(Router);

    public openModule(event: MouseEvent, url: string): Promise<boolean> | void {
        if (this._isNonPrimaryMouseEvent(event)) {
            return;
        }

        event.preventDefault();

        const currentPath: string = this._router.url.split('?')[0];

        if (currentPath === url) {
            return;
        }

        return this._router.navigate([url]);
    }

    public isActiveRoute(url: string): boolean {
        return this._router.url.startsWith(url);
    }

    private _isNonPrimaryMouseEvent(event: MouseEvent): boolean {
        return event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey;
    }
}
